import type { StaticFilterField } from "./StaticFilterField";

/** The events table's filter rows, in picker order. */
export const EVENT_FILTER_FIELDS = [
  { type: "string", field: "event_id", name: "Event Id" },
  { type: "string", field: "name", name: "Name" },
  { type: "string", field: "description", name: "Description" },
  { type: "numeric", field: "duration", name: "Duration (ns)" },
  { type: "date", field: "created", name: "Created" },
  { type: "identity", field: "created_by", name: "Created By" },
  { type: "date", field: "modified", name: "Modified" },
  { type: "identity", field: "modified_by", name: "Modified By" },
  { type: "set", field: "tags", name: "Tags" },
] as const satisfies readonly StaticFilterField[];
